<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-blacklist`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41.995 7.563C41.892 5.585 40.272 4 38.27 4H9.73l-.2.005C7.557 4.11 6 5.76 6 7.762v33.476l.005.2C6.108 43.414 7.728 45 9.73 45H17v-4h-7V8h28v10.401h4V7.761l-.005-.198zM45 34c0-7.18-5.82-13-13-13s-13 5.82-13 13 5.82 13 13 13 13-5.82 13-13zm-20.421-5.093a9 9 0 0012.24 12.696l.274-.182L24.58 28.907zm2.94-2.714A9 9 0 0139.808 38.48L27.52 26.192zM21 20a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1h6zm9-7a1 1 0 00-1-1H15a1 1 0 00-1 1v2a1 1 0 001 1h14a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconBlacklist',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
